/**
 * SLICE A — client mirror of the backend canonical meaningful-resolution rule
 * (backend: solutions_routes.py `_meaningful_steps` + `_PLACEHOLDER_STEPS`).
 * The BACKEND remains authoritative; this only gives the operator a truthful,
 * immediate validation message before a Solution Bank submission. Keep the
 * placeholder set in lockstep with the backend. Generic — no tenant/industry
 * or customer-phrase special-casing.
 */
export const PLACEHOLDER_STEPS = new Set([
  '', 'test', 'test script', 'test scripts', 'done', 'fixed', 'resolved', 'restarted',
  'human agent helped', 'issue closed', 'closed', 'ok', 'okay', 'n/a', 'na', 'none', '-',
]);

/** True iff `text` has at least one non-empty, non-placeholder resolution line. */
export function isMeaningfulResolution(text) {
  const raw = (text || '').trim();
  if (!raw) return false;
  const meaningful = raw
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l && !PLACEHOLDER_STEPS.has(l.toLowerCase()));
  return meaningful.length > 0;
}
